var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rd-button-switcher',{attrs:{"data":_vm.reactiveData.items,"value":_vm.depots}})}
var staticRenderFns = []

export { render, staticRenderFns }